// extracted by mini-css-extract-plugin
export default {"modal":"WarningModal_modal__2FcXY","modalContainer":"WarningModal_modalContainer__CVzuf","buttonContainer":"WarningModal_buttonContainer__XpSW3"};